import React from "react";
import { Link } from "react-router-dom";
const images = require.context("../assets/images", false);

function About_home() {
    return (
<div className="mt-80 about-GEH">
  <div className="container">
    <div className="row align-items-center">
      <div className="col-md-6">
        <div className="about-image mb-3">
          <img className="mt-5" src={images("./HomeAboutUs1.jpg")} />
          <img src={images("./HomeAboutUs2.jpg")} />
        </div>
      </div>
      <div className="col-md-6 justify-content">
        <div className="about-content">
          <div className="grey-text-box">
            VIP | PRIVATE | LUXURY | PERSONALIZED
          </div>
          <h2>The Golden Triangle Tour Expert</h2>
          <p className="justifycontent">
            India is a truly amazing travel destination. It is a country with a
            rich and varied culture and history. The Golden Triangle Tour, the
            most famous and popular tour in the country, provides a brilliant,
            unforgettable introduction to India. The Golden Triangle is formed
            by three of India’s most revered cities: Delhi, Agra and Jaipur.
            These three cities form a triangle some 200 to 250 km along each
            side.&nbsp;Delhi, the diverse capital city of India, is a bustling
            combination of old Imperial grandeur and modernity.{" "}
          </p>
          <p className="justifycontent">
            It has fascinating historical monuments such as the Red Fort, the
            Qutub Minar and the India Gate. At the same time you can visit
            modern gardens and temples....
          </p>
          <Link className="primary-btn mt-3" to="/about-us">
            Read More <img src={images("./arrow-right-btn.svg")} alt="arrow right" />
          </Link>
        </div>
      </div>
    </div>
  </div>
</div>

    );
}

export default About_home;
